<template>
  <GrayBack class="product-description">
    <span class="description-title">{{title}}</span>
    <!-- <span class="description">{{description}}</span> -->
    <span class="description" v-if="description" v-html="description"></span>
    <span class="link_area">
      <!-- <SquareButton
        class="button"
        text="お支払い方法について"
        @handleSquareBtnClick="page('/user-guide#howtopay')"
      />
      <SquareButton
        class="button"
        text="発送方法について"
        @handleSquareBtnClick="page('/user-guide#howtosend')"
      /> -->
      <SquareButton
        class="button"
        :isSub="true"
        :text="t('特定商取引法について')"
        @handleSquareBtnClick="page('/specific-commerce')"
      />
    </span>
  </GrayBack>
</template>

<script>
import SquareButton from '@/components/atoms/SquareButton.vue';
import GrayBack from '@/components/molecules/GrayBack.vue';
import t from '@/plugins/i18n';

export default {
  name: 'ProductDescription',
  mixins: [t],

  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },

  components: {
    GrayBack,
    SquareButton,
  },

  methods: {
    page(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-description{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 19px 14px;
  width: 100%;
  .description-title{
    font-family: $notoSerif;
    font-size: 18px;
    font-weight: 500;
    color: $black;
    width: 100%;
    text-align: center;
    padding-bottom: 20px;
  }
  .description{
    margin-top: 20px;
    font-family: $notoSans;
    font-size: 13px;
    color: $black;
    line-height: 23px;
    white-space: pre-wrap;
    width: 100%;
    padding: 0 20px;
  }
  .link_area {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    padding: 20px 10px;
    width: 100%;
    text-align: center;
    span {
      color: $blue;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .button {
    margin: 0 5px;
    min-width: 180px;
    padding: 0 5px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .product-description{
    padding: 10px 5px;
    .description{
      padding: 0 5px;
    }
    .link_area {
      flex-direction: column;
      span {
        margin: 10px 0;
      }
    }
  }
}
</style>
